import { gql } from "apollo-boost";

const VIEWER = gql`
  query Viewer {
    viewer {
      id
      email
    }
  }
`;

export default VIEWER;
